import React from 'react';


function footer (props) {
return ( 
    
    <footer>
 
                {/* Footer-bottom-widgets */}
                <div className="pt-8 pb-4 bg-gray-13">
                    <div className="container mt-1">
                        <div className="row">
                            <div className="col-lg-5">
                                
                                <div className="mb-4">
                                    <div className="row no-gutters">
                                        <div className="col-auto">
                                            <i className="ec ec-support text-primary font-size-56"></i>
                                        </div>
                                        <div className="col pl-3">
                                            <div className="font-size-13 font-weight-light">Got questions? Mail us </div>
                                                <a href="mail:support@shopmuthu.com" className="font-size-20 text-gray-90">support@shopmuthu.com </a>
                                            </div>
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <h6 className="mb-1 font-weight-bold">Contact info</h6>
                                    <address className="">
                                       support@shopmuthu.com
                                    </address>
                                </div>
                              
                            </div>
                            <div className="col-lg-7">
                                <div className="row">
                                                                 
                                    <div className="col-12 col-md mb-4 mb-md-0">
                                        <h6 className="mb-3 font-weight-bold">Customer Care</h6>
                                        {/* List Group */}
                                        <ul className="list-group list-group-flush list-group-borderless mb-0 list-group-transparent">
                                            <li><a className="list-group-item list-group-item-action" href="/page/about-us">About Us</a></li>
                                            <li><a className="list-group-item list-group-item-action" href="/page/privacy-policy">Privacy Policy</a></li>
                                            <li><a className="list-group-item list-group-item-action" href="/page/contact-us">Contact us</a></li>                           
                                            
                                        </ul>
                                        {/* End List Group */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Footer-bottom-widgets */}
                {/* Footer-copy-right */}
                <div className="bg-gray-14 py-2">
                    <div className="container">
                        <div className="flex-center-between d-block d-md-flex">
                            <div className="mb-3 mb-md-0">© <a href="/" className="font-weight-bold text-gray-90">ShopMuthu</a> - All rights Reserved</div>
                            
                        </div>
                    </div>
                </div>
                {/* End Footer-copy-right */}
            </footer>
            
    
    );
}

export default footer;